import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Form, Typography, Table, Button, Input, Icon, Spin, Select, DatePicker } from 'antd';
import ViewList from '@material-ui/icons/ViewList';
// import { green } from '@material-ui/core/colors';
import Highlighter from 'react-highlight-words';
import * as SignalR from '@aspnet/signalr';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';
import ApiCaller from '../../../utils/api-caller';
import * as XLSX from 'xlsx';
import 'antd/dist/antd.css';

const { Title } = Typography;
const { Option } = Select;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;

@inject(
    'PaymentLogStore'
)
@observer
class PaymentLogListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: '',
            fromDate: undefined,
            toDate: undefined,
            paymentStatus: 'ALL',
            orderStatus: 'ALL',
            roomNo: '',
            lastName: '',
            pagination: {
                current: 1,
                pageSize: 10,
            }
        }
    }

    componentDidMount() {
        let fromDateTime = moment();
        fromDateTime.hour(0);
        fromDateTime.minute(0);
        fromDateTime.second(0);

        let toDateTime = moment();
        toDateTime.hour(23);
        toDateTime.minute(59);
        toDateTime.second(0);

        this.setState({
            fromDate: fromDateTime,
            toDate: toDateTime,
            paymentStatus: 'ALL',
            orderStatus: 'ALL',
            roomNo: '',
            lastName: '',
        }, () => {
            const { pagination } = this.state;
            this.getFilterData({ pagination });
        });

        let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
        connection.start().catch(function (err) { return console.error(err.toString()); });
        connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
    }

    // Server Table Pagination

    getFilterData = (params = {}) => {
        const fromDate = moment(this.state.fromDate).format('YYYY-MM-DDTHH:mm:ss')
        const endDate = moment(this.state.toDate).format('YYYY-MM-DDTHH:mm:ss')

        this.props.PaymentLogStore.initPaymentLog(
            fromDate,
            endDate,
            params.pagination.current,
            params.pagination.pageSize,
            this.state.paymentStatus,
            this.state.orderStatus,
            this.state.roomNo,
            this.state.lastName
        ).then(() => {
            const { totalData } = this.props.PaymentLogStore;

            this.setState({
                pagination: {
                    ...params.pagination,
                    total: totalData
                }
            })
        });
    }

    handleTableChange = (pagination, filters, sorter) => {
        this.getFilterData({
            sortField: sorter.field,
            sortOrder: sorter.order,
            pagination,
            ...filters,
        });
    }

    // ON CLICK

    updatePaymentLogOnClick = (id) => {
        this.props.PaymentLogStore.initUpdatePaymentLog(id);
    }

    // TABLE SETTING

    getColumns = () => {
        const { t } = this.props;
        return [
            {
                title: t('#ID'),
                dataIndex: 'paymentId',
                key: 'paymentId',
            },
            {
                title: t('Amount'),
                dataIndex: 'amount',
                key: 'amount',
                render: amount => {
                    return (
                        <span>{Math.round(amount * 100) / 100}</span>
                    )
                }
            },
            {
                title: t('Payment Created Date'),
                dataIndex: 'paymentCreatedAtString',
                key: 'paymentCreatedAtString'
            },
            // {
            //     title: 'Payment Success Date',
            //     dataIndex: 'paymentSuccessAtString',
            //     key: 'paymentSuccessAtString',
            // },
            // {
            //     title: 'Order Completed Date',
            //     dataIndex: 'orderCompletedAtString',
            //     key: 'orderCompletedAtString',
            // },
            {
                title: t('Payment Status'),
                dataIndex: 'paymentStatus',
                key: 'paymentStatus',
            },
            {
                title: t('Order Status'),
                dataIndex: 'orderStatus',
                key: 'orderStatus',
            },
            {
                title: t('Room No'),
                dataIndex: 'roomNo',
                key: 'roomNo',
            },
            {
                title: t('Last Name'),
                dataIndex: 'lastName',
                key: 'lastName',
            },
            {
                title: t('Action'),
                dataIndex: 'id',
                key: 'id',
                render: id => (
                    <span>
                        <Button onClick={() => this.updatePaymentLogOnClick(id)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <ViewList style={{ color: '#1890ff', fontSize: 24 }} />
                        </Button>
                    </span>
                ),
            },
        ]
    }

    getColumnSearchProps = dataIndex => {
        const { t } = this.props;
        return ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={node => {
                            this.searchInput = node
                        }}
                        placeholder={t(`Search ${dataIndex}`)}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type='primary'
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon='search'
                        size='small'
                        style={{ width: 90, marginRight: 8 }}
                    >
                        {t('Search')}
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size='small' style={{ width: 90 }}>
                        {t('Reset')}
                    </Button>
                </div>
            ),
        filterIcon: filtered => (
            <Icon type='search' style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                text
            ),
        });
    };

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    fromDateChange = (e) => {
        this.setState({
            fromDate: e
        })
    }

    toDateChange = (e) => {
        this.setState({
            toDate: e
        })
    }

    paymentStatusChange = (value) => {
        this.setState({
            paymentStatus: value
        })
    }

    orderStatusChange = (value) => {
        this.setState({
            orderStatus: value
        })
    }

    roomNoChange = (e) => {
        this.setState({
            roomNo: e.target.value
        })
    }

    lastNameChange = (e) => {
        this.setState({
            lastName: e.target.value
        })
    }

    searchData = () => {
        const { pagination } = this.state;
        this.getFilterData({ pagination });
    }

    exportOnClick = () => {
        const fromDate = moment(this.state.fromDate).format('YYYY-MM-DDTHH:mm:ss')
        const endDate = moment(this.state.toDate).format('YYYY-MM-DDTHH:mm:ss')

        let fromDateTime = moment(fromDate).format('DD/MM/YYYY');
        let toDateTime = moment(endDate).format('DD/MM/YYYY');

        var request = {
            'fromDate': fromDateTime,
            'toDate': toDateTime,
            'currentPage': 1,
            'pageSize': 10000,
            'paymentStatus': this.state.paymentStatus,
            'orderStatus': this.state.orderStatus,
            'roomNo': this.state.roomNo,
            'lastName': this.state.lastName
        };

        return ApiCaller.PaymentLogs.get(request).then(resp => {
            let paymentLogs = [];
            if (resp.isSuccess) {
                resp.model.map(m => {
                    return m.createdDate = moment(m.createdDate).format('DD/MM/yyyy HH:mm:ss');
                })
                paymentLogs = resp.model;
            }

            const renamedData = paymentLogs.map(item => ({
                'ID': item.id,
                'Payment ID': item.paymentId,
                'Payment Created At': item.paymentCreatedAtString,
                'Payment Success At': item.paymentSuccessAtString,
                'Order Completed At': item.orderCompletedAtString,
                'Payment Status': item.paymentStatus,
                'Order Status': item.orderStatus,
                'Amount': item.amount.toFixed(2),
                'Room No': item.roomNo,
                'Last Name': item.lastName,
                'Customer ID': item.customerId,
                'Reservation Number': item.reservationNumber,
                'Order Detail': item.orderDetail
            }));

            // TODO Export Excel
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(renamedData);

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Payment History');
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'PaymentHistory.xlsx');
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
        });
    }

    render() {
        const { t } = this.props;
        const {
            paymentLogs,
            paymentLogListLoading,
            paymentStatuses,
            orderStatuses,
        } = this.props.PaymentLogStore;

        const { pagination } = this.state;

        return (
            <React.Fragment>
                <Form layout='horizontal'>
                    <div style={{ marginBottom: 20 }}>
                        <Title level={3}>{t('List')}</Title>
                        <div style={{ display: 'flex', alignItems: 'center', height: 48 }}>
                            <div style={{ paddingRight: 8, width: 80 }}>{t('From Date')}</div>
                            <div style={{ paddingRight: 16 }}>
                                <DatePicker
                                    format='YYYY/MM/DD'
                                    value={this.state.fromDate}
                                    onChange={(e) => this.fromDateChange(e)}
                                />
                            </div>
                            <div style={{ paddingRight: 8, width: 120 }}>{t('Payment Status')}</div>
                            <div style={{ paddingRight: 16 }}>
                                <Select
                                    value={this.state.paymentStatus}
                                    onChange={(value) => this.paymentStatusChange(value)}
                                    style={{ width: 120 }}>
                                    {
                                        paymentStatuses.map(paymentStatus => {
                                            return (<Option key={paymentStatus.value} value={paymentStatus.value}>{paymentStatus.label}</Option>)
                                        })
                                    }
                                </Select>
                            </div>
                            <div style={{ paddingRight: 8, width: 80 }}>{t('Room No')}</div>
                            <div style={{ paddingRight: 16 }}>
                                <Input value={this.state.roomNo} placeholder={t('Room No')} onChange={this.roomNoChange} />
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', height: 48 }}>
                            <div style={{ paddingRight: 8, width: 80 }}>{t('To Date')}</div>
                            <div style={{ paddingRight: 16 }}>
                                <DatePicker
                                    format='YYYY/MM/DD'
                                    value={this.state.toDate}
                                    onChange={(e) => this.toDateChange(e)}
                                />
                            </div>
                            <div style={{ paddingRight: 8, width: 120 }}>{t('Order Status')}</div>
                            <div style={{ paddingRight: 16 }}>
                                <Select
                                    value={this.state.orderStatus}
                                    onChange={(value) => this.orderStatusChange(value)}
                                    style={{ width: 120 }}>
                                    {
                                        orderStatuses.map(orderStatus => {
                                            return (<Option key={orderStatus.value} value={orderStatus.value}>{orderStatus.label}</Option>)
                                        })
                                    }
                                </Select>
                            </div>
                            <div style={{ paddingRight: 8, width: 80 }}>{t('Last Name')}</div>
                            <div style={{ paddingRight: 16 }}>
                                <Input value={this.state.lastName} placeholder={t('Last Name')} onChange={this.lastNameChange} />
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', height: 48 }}>
                            <div style={{ paddingLeft: 80 }}>
                                <Button onClick={this.searchData} style={{ marginRight: 8 }}>{t('Search')}</Button>
                                {/* <Button onClick={this.exportOnClick}>Export</Button> */}
                                {/* {(!this.state.exportingPaymentHistory) ? '' :
                                    <ExcelFile filename="PaymentHistory" hideElement={true}>
                                        <ExcelSheet data={this.state.exportPaymentHistoryDataSet} name="Payment History">
                                            <ExcelColumn label="#ID" value="id" />
                                            <ExcelColumn label="#Payment ID" value="paymentId" />
                                            <ExcelColumn label="Amount" value="amount" />
                                            <ExcelColumn label="Payment Status" value="paymentStatus" />
                                            <ExcelColumn label="Order Status" value="orderStatus" />
                                            <ExcelColumn label="Room No" value="roomNo" />
                                            <ExcelColumn label="Last Name" value="lastName" />
                                            <ExcelColumn label="Payment Created Date" value="paymentCreatedAtString" />
                                            <ExcelColumn label="Payment Success Date" value="paymentSuccessAtString" />
                                            <ExcelColumn label="Order Completed Date" value="orderCompletedAtString" />
                                            <ExcelColumn label="Detail" value="orderDetail" />
                                        </ExcelSheet>
                                    </ExcelFile>
                                } */}
                            </div>
                        </div>
                    </div>
                    <Spin spinning={paymentLogListLoading}>
                        <Table
                            columns={this.getColumns()}
                            rowKey={record => record.id}
                            dataSource={paymentLogs}
                            pagination={pagination}
                            onChange={this.handleTableChange} />
                    </Spin>
                </Form>
            </React.Fragment>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(PaymentLogListPage);